import React from 'react';
import { Input } from '@/components/ui/input';
import { followupError, isBlank } from '@/lib/choiceFollowups';

/* Respondent: inline follow-up shown directly below the selected answer option. */
export default function ChoiceFollowup({ cfg, value, onChange, qid }) {
  const id = `followup-input-${qid}`;
  const err = isBlank(value) ? null : followupError(cfg, value);
  const isNumber = cfg.field_type === 'number';
  return (
    <div className="pt-1 pb-1" data-testid={`followup-${qid}`}>
      <label htmlFor={id} className="block text-xs font-semibold text-[#64748B] mb-1.5" data-testid={`followup-label-${qid}`}>
        {cfg.label}{cfg.required ? '' : ' (optional)'}
      </label>
      {cfg.field_type === 'dropdown' ? (
        <select id={id} value={value ?? ''} onChange={(e) => onChange(e.target.value)} autoFocus
          className="w-full border border-[#CBD5E1] rounded-md px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#214A7B]"
          data-testid={`followup-select-${qid}`}>
          <option value="">Choose…</option>
          {(cfg.choices || []).map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
      ) : (
        <Input id={id} type={isNumber ? 'number' : 'text'} inputMode={isNumber ? 'decimal' : undefined}
          min={isNumber && cfg.min_value != null ? cfg.min_value : undefined}
          max={isNumber && cfg.max_value != null ? cfg.max_value : undefined}
          step={isNumber ? 'any' : undefined} maxLength={isNumber ? undefined : 500}
          value={value ?? ''} onChange={(e) => onChange(e.target.value)} autoFocus
          className="h-11 text-base" data-testid={`followup-input-${qid}`} />
      )}
      {err && <p className="text-xs text-red-500 mt-1" data-testid={`followup-error-${qid}`}>{err}</p>}
    </div>
  );
}
